import React from "react";
import { Link } from "react-router-dom";
import { useT } from "../lib/i18n";
import useSEO from "../lib/useSEO";
import { breadcrumbLd } from "../lib/jsonld";

export default function Services() {
  const { t } = useT();
  useSEO({
    title: "Services — Warehouse Leasing, Cold Storage, Logistics & Industrial Units in Dubai | WarehousesUAE",
    description: "Warehouse leasing, GDP cold storage, industrial units, showrooms, logistics hubs and storage units across Dubai's free zones and mainland. Direct landlord access via WarehousesUAE.com.",
    canonical: window.location.origin + "/services",
    image: window.location.origin + "/og-default.png",
    jsonLd: breadcrumbLd([{ name: "Home", url: "/" }, { name: "Services", url: "/services" }]),
  });
  const SERVICES = [
    { n: "01", title: t("services.s1_t"), d: t("services.s1_d"), img: "https://images.unsplash.com/photo-1601599963565-b7f49deb3d50?w=900" },
    { n: "02", title: t("services.s2_t"), d: t("services.s2_d"), img: "https://images.unsplash.com/photo-1553413077-190dd305871c?w=900" },
    { n: "03", title: t("services.s3_t"), d: t("services.s3_d"), img: "https://images.unsplash.com/photo-1565891741441-64926e441838?w=900" },
    { n: "04", title: t("services.s4_t"), d: t("services.s4_d"), img: "https://images.unsplash.com/photo-1604754742629-3e0498a26df3?w=900" },
    { n: "05", title: t("services.s5_t"), d: t("services.s5_d"), img: "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?w=900" },
    { n: "06", title: t("services.s6_t"), d: t("services.s6_d"), img: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=900" },
    { n: "07", title: t("services.s7_t"), d: t("services.s7_d"), img: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=900" },
    { n: "08", title: t("services.s8_t"), d: t("services.s8_d"), img: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=900" },
  ];

  return (
    <div data-testid="services-page" className="bg-zinc-50 min-h-screen">
      <div className="bg-white border-b border-zinc-200 py-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="font-mono-tech text-[10px] uppercase text-[#031833] mb-3">{t("services.hero_kicker")}</div>
          <h1 className="font-display text-5xl md:text-7xl tracking-tighter leading-[0.95]">
            {t("services.hero_title_a")}<br />{t("services.hero_title_b")}<br />{t("services.hero_title_c")}
          </h1>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {SERVICES.map((s) => (
          <div key={s.n} data-testid={`service-${s.n}`} className="bg-white border border-zinc-200 hover:border-zinc-900 transition-colors">
            <div className="aspect-[16/10] overflow-hidden bg-zinc-100">
              <img src={s.img} alt={s.title} className="w-full h-full object-cover" />
            </div>
            <div className="p-6">
              <div className="font-mono-tech text-[10px] text-[#031833] mb-3">{s.n} //</div>
              <h2 className="font-display text-2xl tracking-tighter mb-2">{s.title}</h2>
              <p className="text-sm text-zinc-600 leading-relaxed">{s.d}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-[#FFCC00] py-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
          <h2 className="font-display text-4xl md:text-5xl tracking-tighter mb-6">{t("services.cta_title")}</h2>
          <p className="max-w-2xl mx-auto mb-6">{t("services.cta_sub")}</p>
          <Link to="/contact" data-testid="services-contact-btn" className="inline-block bg-zinc-950 text-white font-mono-tech text-sm uppercase px-8 py-4 hover:bg-[#031833]">{t("services.cta_btn")}</Link>
        </div>
      </div>
    </div>
  );
}
